import React, { useEffect, useState } from "react";
import RestClient from "../../../common/RestClient";
import { toast } from "react-toastify";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  campaignAtom,
  campaignGlobalRefreshAtom,
  isSelectedPerformanceConditionsAtom,
  locationsAtom,
  locationVenuesSelector,
  validForSpecificLocationVenueSelector,
} from "../CampaignState";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { LocationHallConditionDialog } from "../dialogs/LocationHallConditionDialog";
import { BaseTableCondition } from "../common/BaseTableCondition";

export const LocationHallConditionCard = (props) => {
  const campaign = useRecoilValue(campaignAtom);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [refresh, setRefresh] = useState(0);
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  const [showTable, setShowTable] = useState(false);
  const [showDeleteAllConfirmation, setShowDeleteAllConfirmation] =
    useState(false);
  const [data, setData] = useState([]);
  const isSelectedPerformance = useRecoilValue(
    isSelectedPerformanceConditionsAtom
  );
  const locations = useRecoilValue(locationsAtom);
  const locationVenues = useRecoilValue(locationVenuesSelector);

  const globalRefresh = useRecoilValue(campaignGlobalRefreshAtom);
  const validForSpecificLocationVenue = useSetRecoilState(
    validForSpecificLocationVenueSelector
  );

  const { isEdit } = props;

  const handleError = (error) => {
    toast.error(error.message);
  };

  useEffect(() => {
    setShowTable(campaign.validForSpecificLocationVenue);
  }, [campaign]);

  useEffect(() => {
    if (campaign.id === 0) {
      return;
    }
    RestClient.sendGetRequestWithParameters(
      "api/v1/campaign_validity_conditions/location_venue",
      { campaignId: campaign.id },
      (response) => {
        setData(response.data);
      },
      handleError
    );
  }, [campaign.id, refresh, globalRefresh]);

  const onDeleteElement = () => {
    RestClient.sendDeleteRequest(
      `api/v1/campaign_validity_conditions/location_venue/${selectedId}`,
      () => {
        setRefresh((r) => r + 1);
        toast.success(
          "The location hall condition has been deleted successful."
        );
        validForSpecificLocationVenue(data.length > 1);
      },
      handleError
    );
    setShowDeleteConfirmation(false);
  };

  const onCreate = (locationId, locationHallIds) => {
    const params = {
      locationId: locationId,
      locationVenueIds: locationHallIds,
      campaignId: campaign.id,
    };
    RestClient.sendPostRequest(
      "api/v1/campaign_validity_conditions/location_venue",
      params,
      (_) => {
        setRefresh((r) => r + 1);
        validForSpecificLocationVenue(true);
        toast.success(
          "The campaign location hall condition has been created successful."
        );
      },
      handleError
    );
    setShowCreateDialog(false);
  };

  const onDeleteAll = () => {
    RestClient.sendDeleteRequest(
      `api/v1/campaign_validity_conditions/${campaign.id}/all_location_venue_conditions`,
      () => {
        toast.success(
          "All location venue conditions have been deleted successful."
        );
        setRefresh((ref) => ref + 1);
        validForSpecificLocationVenue(false);
      },
      handleError
    );
    setShowDeleteAllConfirmation(false);
  };

  return (
    <>
      <div className="form-group row">
        <label className="col-sm-2 col-form-label">
          Location Hall Condition
        </label>
        <div className="col-sm-6">
          <div className="">
            <input
              disabled={isSelectedPerformance || !isEdit}
              className="mr-1"
              type="radio"
              name="LocationHallCondition"
              id="LocationHallConditionRbNo"
              value="No"
              checked={!showTable}
              onChange={() => {
                setShowTable(false);
                if (data && data.length > 0) {
                  setShowDeleteAllConfirmation(true);
                }
              }}
            />
            <label
              className="form-check-label"
              htmlFor="LocationHallConditionRbNo"
            >
              No Location Hall restriction
            </label>
          </div>
          <div className="">
            <input
              disabled={isSelectedPerformance || !isEdit}
              className="mr-1"
              type="radio"
              name="LocationHallCondition"
              id="LocationHallConditionRbYes"
              value="Yes"
              checked={showTable}
              onChange={() => setShowTable(true)}
            />
            <label
              className="form-check-label"
              htmlFor="LocationHallConditionRbYes"
            >
              Valid for specific location hall
            </label>
            <button
              type="button"
              className="btn btn-sm btn-outline-primary float-right"
              disabled={!showTable || !isEdit}
              onClick={() => setShowCreateDialog(true)}
            >
              Add Condition
            </button>
          </div>
        </div>
      </div>
      {showTable && (
        <BaseTableCondition>
          <thead>
            <tr>
              <th>Location</th>
              <th>Location Hall</th>
              <th style={{ width: "10%" }} />
            </tr>
          </thead>
          <tbody>
            {data &&
              data.map((x, index) => {
                const location = locations.find((l) => l.id === x.locationId);
                const locationVenue = locationVenues.find(
                  (lv) => lv && lv.id === x.locationVenueId
                );
                return (
                  <tr key={index}>
                    <td>{location?.name}</td>
                    <td>{locationVenue?.name}</td>
                    <td>
                      <button
                        className="btn btn-sm btn-danger"
                        onClick={() => {
                          setSelectedId(x.id);
                          setShowDeleteConfirmation(true);
                        }}
                        disabled={!isEdit}
                      >
                        <i className="far fa-trash-alt" aria-hidden="true" />
                      </button>
                    </td>
                  </tr>
                );
              })}
          </tbody>
        </BaseTableCondition>
      )}
      <ConfirmDialog
        visible={showDeleteConfirmation}
        onProceed={onDeleteElement}
        onCancel={() => setShowDeleteConfirmation(false)}
        message="Are you sure to delete the condition?"
      />
      <LocationHallConditionDialog
        visible={showCreateDialog}
        onConfirm={onCreate}
        onCancel={() => setShowCreateDialog(false)}
      />
      <ConfirmDialog
        visible={showDeleteAllConfirmation}
        onProceed={onDeleteAll}
        onCancel={() => {
          setShowDeleteAllConfirmation(false);
          setShowTable(true);
        }}
        message="All the added conditions will be deleted?"
      />
    </>
  );
};
